import { CustomSearchCriteria } from '@catalog/const';
import { Action } from '@ngrx/store';
import { Product, ProductActions, ProductSearchPage } from '@spartacus/core';

export const LOAD_PRODUCTS_BY_CODES = '[CustomCatalog] Load Products By Codes';
export const LOAD_PRODUCTS_BY_CODES_FAIL = '[CustomCatalog] Load Products By Codes Fail';
export const LOAD_PRODUCTS_BY_CODES_SUCCESS = '[CustomCatalog] Load Products By Codes Success';

export const LOAD_MORE_PRODUCTS = '[CustomCatalog] Load More Products';
export const LOAD_MORE_PRODUCTS_SUCCESS = '[CustomCatalog] Load More Products Success';
export const LOAD_MORE_PRODUCTS_RESET = '[CustomCatalog] Load More Products Reset';

export class LoadProductsByCodes implements Action {
  readonly type = LOAD_PRODUCTS_BY_CODES;

  constructor(
    public productCodes: string[],
    public scope: string,
  ) {}
}

export class LoadProductsByCodesFail implements Action {
  readonly type = LOAD_PRODUCTS_BY_CODES_FAIL;

  constructor(
    public productCodes: string[],
    public scope: string,
  ) {}
}

export class LoadProductsByCodesSuccess implements Action {
  readonly type = LOAD_PRODUCTS_BY_CODES_SUCCESS;

  constructor(
    public productCodes: string[],
    public products: Product[],
    public scope: string,
  ) {}
}

export class LoadMoreProducts implements Action {
  readonly type = LOAD_MORE_PRODUCTS;

  constructor(public payload: CustomSearchCriteria) {}
}

export class LoadMoreProductsFail extends ProductActions.SearchProductsFail {}

export class LoadMoreProductsSuccess implements Action {
  readonly type = LOAD_MORE_PRODUCTS_SUCCESS;

  constructor(public payload: ProductSearchPage) {}
}

export class LoadMoreProductsReset implements Action {
  readonly type = LOAD_MORE_PRODUCTS_RESET;
}

// action types
export type LoadProductsAction =
  | LoadProductsByCodes
  | LoadProductsByCodesFail
  | LoadProductsByCodesSuccess
  | LoadMoreProducts
  | LoadMoreProductsFail
  | LoadMoreProductsSuccess
  | LoadMoreProductsReset;
